import { useState, useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { DispatchContext, StateContext } from '../../App';
import './DialogWindow.css';

const DialogWindow = () => {
    const dispatch = useContext(DispatchContext);
    const appState = useContext(StateContext);

    const handleClick = (action) => {
        dispatch({
            type: 'SET_IS_APP_ACTIVE',
            payload: true
        });

        if (action === 'confirm') {
            dispatch({
                type: 'RESET_APP',
                payload: {
                    isArticleSelected: false,
                    filter: {
                        init: 'categories'
                    }
                }
            })
            
        } 
    };

    return (
        <div className='mask'>
            <div className='dialog-window shadow'>
                <div className='dialog-message'>
                    <FormattedMessage 
                        id='dialog_message_reset'
                        defaultMessage='By clicking "Yes" button your composition will be permanently deleted, click "Cancel" in case you want to continue'
                    />
                </div>
                <div className='dialog-btn-container'>
                    <button className='dialog-btn' onClick={() => handleClick('cancel')}>
                        <FormattedMessage 
                            id='cancel'
                            defaultMessage='Cancel'
                        />
                    </button>
                    <button className='dialog-btn active-btn' onClick={() => handleClick('confirm')}>
                        <FormattedMessage 
                            id='confirm'
                            defaultMessage='Confirm'
                        />
                    </button>
                </div>
            </div>
        </div>
    )
};

export default DialogWindow;